import { ESpineAnimationSkipMode } from '@Core/Animation/SpineAnimationSequence';
import { EEmitterLayer } from '@Core/Win/Elements/ParticleEmitter';
import { IWinConfiguration } from '@Core/Win/WinPresentation.types';
import { EGameEvents } from '@Managers/Events/GameEvents';

export const WIN_CONFIGURATION_DEFAULTS: IWinConfiguration = {
    useGeneratedWinlines: false,
    highlightAllWinningSymbols: false,
    generatedWinlineConfig: {
        alpha: 1,
        width: 10,
        color: 'ffffff',
        colors: [],
        borderOffset: 35,
        duration: 1000
    },
    odometer: {
        fontKey: '',
        fontSize: 0,
        hideAfterSpinDelay: 0,
        holdDuration: 0
    },
    particleEmitters: [
        {
            name: '',
            atlas: '',
            prefix: '',
            frames: 0,
            frameRate: 0,
            landscapeX: 0,
            landscapeY: 0,
            portraitX: 0,
            portraitY: 0,
            layer: EEmitterLayer.UNDER_WIN,
            burst: false,
            quantity: 1
        }
    ],
    winMultiplierPresentation: {
        spineKey: '',
        animationNames: [],
        skip: {
            mode: ESpineAnimationSkipMode.ALL
        },
        active: false,
        startEvent: EGameEvents.ASSETS_PRELOAD_FINISHED,
        endEvent: EGameEvents.ASSETS_PRELOAD_FINISHED
    }
};
